import React, { useState, useEffect  } from 'react'
import axios from 'axios';
import TabLink from './TabLinks';
function Faq() {
const [posts, setPosts] = useState([]);
const [loading, setLoading] = useState(false);
let api = 'https://tallysolutions-uae.com/tallyprime/api/wp-json/wp/v2/faq';
useEffect(() => {
setLoading(true)
axios.get(api)
.then(res => {
//console.log(res)
setPosts(res.data)
setLoading(false)
})
}, [setPosts])
return (
<React.StrictMode>
   {
   loading && 
   <section className="bg-gray pt-5"><img src="https://tallysolutions-uae.com/tallyprime//assets/img/loading.gif" alt="loading" className="mx-auto d-block mt-5 pt-5" width="20" /></section>
   }
   {!loading &&
   <>
   <section className="bg-gray pt-lg-5 pb-3 pb-lg-5" >





      <div className="container  pt-lg-5 mb-md-5">
         <div className="row">
            <div className="col-md-12">
               <div className="tabbable tabs-left">
                  <div className="row">
                     <div className="col-md-3 clearfix d-flex d-md-none align-items-top justify-content-center mb-3 mb-lg-5">
                        <TabLink/>
                     </div>
                     <div className="col-md-8" id="faq-qua">
                        <div className="tab-content w-100">
                           {posts.map((post,i) => (
                           <div  className={i ? 'tab-pane fade' : 'tab-pane active'}  id={post.acf.type.replace(/-|\s/g, '_').toLowerCase()}>
                           <span  dangerouslySetInnerHTML={{ __html: post.content.rendered }} />
                        </div>
                        ))}
                     </div>
                  </div>
                  <div className="col-md-3 offset-md-1 clearfix d-none d-md-flex align-items-top justify-content-center">
                     <TabLink/>
                  </div>
               </div>
            </div>
         </div>
      </div>
      </div>
   </section>
   </>
   }
</React.StrictMode>
)
}
export default Faq;